<!--
component: KaihatsuTypeModal
description: 開発・造成・土石の堆積の種別選択コンポーネント
-->
<template>
  <v-dialog
    v-model="isOpen"
    max-width="700px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        class="ml-1 help-icon-btn"
        ref="helpBtn"
      >
        <v-icon color="grey">mdi-help-circle-outline</v-icon>
      </v-btn>
    </template>

    <div class="modal-content">
      <div class="modal-header">
        <h3>許可の種別について</h3>
        <v-btn
          icon
          @click="isOpen = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="modal-body">
        <div class="tooltip-section">
          <div class="section-desc">
            <p>番号検索にあたり、許可の基準となる法律・行為によって区分されています。</p>
            <p>各ボタンの選択は以下の通りにご対応ください。</p>
          </div>
          <div class="items-container">
            <div class="item-row">
              <div class="item-label">①開発</div>
              <div class="item-desc">都市計画法に基づく開発許可です。許可番号の区分が「開」の時に選択ください。<span class="example">（例：0000開0000）</span></div>
            </div>

            <div class="item-row">
              <div class="item-label">②旧宅造<br>（～R5）</div>
              <div class="item-desc">宅地造成等規制法に基づく宅地造成の許可です。許可番号の区分が「規」の時に選択ください。<span class="example">（例：0000規0000）</span></div>
            </div>
          </div>
        </div>
        
        <div class="tooltip-divider"></div>
        
        <div class="tooltip-section">
          <div class="section-desc">
            <p>以下の４つは宅地造成及び特定盛土等規制法（盛土規制法）に基づく許可です。</p>
          </div>
          <div class="items-container">
            <div class="item-row">
              <div class="item-label">③宅地造成</div>
              <div class="item-desc">宅地における造成行為の許可です。許可番号の区分が「宅規」の時に選択ください。<span class="example">（例：0000宅規0000）</span></div>
            </div>
            <div class="item-row">
              <div class="item-label">④農地造成</div>
              <div class="item-desc">農地における造成行為の許可です。許可番号の区分が「農規」の時に選択ください。<span class="example">（例：0000農規0000）</span></div>
            </div>
            <div class="item-row">
              <div class="item-label">⑤森林造成</div>
              <div class="item-desc">森林における造成行為の許可です。許可番号の区分が「森規」の時に選択ください。<span class="example">（例：0000森規0000）</span></div>
            </div>
            <div class="item-row">
              <div class="item-label">⑥土石の堆積</div>
              <div class="item-desc">土石の堆積の許可です。許可番号の区分が「土規」の時に選択ください。<span class="example">（例：0000土規0000）</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'KaihatsuTypeModal',
  data() {
    return {
      isOpen: false
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.$refs.helpBtn) {
        this.$refs.helpBtn.$el.blur();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  background: white;
  border-radius: 8px;
  overflow: hidden;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: #afdfdf;
    
    h3 {
      margin: 0;
      color: rgba(0, 0, 0, 0.87);
      font-size: 1.2em;
      font-weight: 500;
    }
  }

  .modal-body {
    padding: 24px;
  }
}

.tooltip-section {
  margin: 0;
  
  .section-desc {
    margin: 8px 0;
    
    p {
      margin: 8px 0;
      
      & + p {
        margin: 1px 0;
      }

      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .items-container {
    padding: 0;

    .item-row {
      display: flex;
      padding: 8px;
      gap: 8px;

      &:nth-child(odd) {
        background-color: rgba(0, 0, 0, 0.04);
      }

      &:nth-child(even) {
        background-color: rgba(0, 0, 0, 0.08);
      }

      .item-label {
        font-size: 1em;
        flex: 0 0 120px;
        font-weight: 500;
      }

      .item-desc {
        flex: 1;

        .example {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
}

.tooltip-divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
  margin: 16px 0;
}

.help-icon-btn {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  position: relative !important;
  
  &::before {
    border-radius: 50%;
    width: 140% !important;
    height: 140% !important;
    transform: translate(-14%, -14%) !important;
  }

  // ホバー効果
  &:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
  }

  // フォーカス時の視覚効果を無効化
  &:focus {
    outline: none !important;
    background-color: transparent !important;
  }
}
</style> 